module.exports = __webpack_public_path__ + "img/loading_indicator.65376c34.svg";